import { camelizeKeys } from 'humps';

import { AddonOrderItem, ApplicableAddonProps, ApplicableAddonsResponse } from './types';
import { post, put } from 'services/api';

/**
 * The add-ons the widget would show for this event: the union of add-ons whose rules could match any of
 * the event's ticket types (each requested at quantity 1). Camelized to the green `ApplicableAddonProps`
 * shape so the cache stores ready-to-render rows (no `select` indirection).
 */
export const getApplicableAddons = async (
	eventId: number,
	ticketTypeIds: number[]
): Promise<ApplicableAddonProps[]> => {
	const ticketTypes: Record<string, number> = {};
	ticketTypeIds.forEach((id) => {
		ticketTypes[id.toString()] = 1;
	});

	const data = await post('/public/ticketing/addons/applicable', {
		event_id: eventId,
		ticket_types: ticketTypes,
	});

	return (camelizeKeys(data) as unknown as ApplicableAddonsResponse).applicableAddons ?? [];
};

/**
 * Persist a new add-on display order. Ordering is partner-scoped on the backend, so the new order applies
 * to every event of the partner (a known limitation — per-event ordering is deferred backend work).
 */
export const reorderAddonsPut = async (addons: AddonOrderItem[]) =>
	put(
		'/addons/reorder',
		addons.map(({ iD, orderIndex }) => ({ ID: iD, order_index: orderIndex }))
	);
